import BrokerCreationTemplate from "./BrokerCreationTemplate";
import PersonSelect from "./PersonSelect";
import Disabled from "components/common/Disabled";
import {
  RETAIL_BROKER_API_NAME,
  useGetSortedBrokerList,
  useGetSortedBrokerListWithRefresh,
} from "components/inputs/program/BrokerSupport";
import * as labels from "config.labels";
import { useSelector, useDispatch } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as peopleActions from "store/actions/people/peopleActions";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as peopleSelectors from "store/selectors/people/peopleSelectors";

const RetailBrokerCreation = ({ onCreate, onClose }) => {
  const brokers = useGetSortedBrokerList(RETAIL_BROKER_API_NAME);

  const [createBroker] = staticDataService.useCreateRetailBrokerMutation();

  return (
    <BrokerCreationTemplate
      brokers={brokers}
      createBroker={createBroker}
      visibilityBaseTag={"<BrokerCreation>"}
      formId={"retail-broker-creation-form"}
      title={"Add a new retail broker"}
      onCreate={onCreate}
      onClose={onClose}
    />
  );
};

const RetailBroker = () => {
  const dispatch = useDispatch();

  const broker = useSelector(peopleSelectors.selectRetailBroker);

  const updateBroker = (value) => {
    dispatch(peopleActions.updateRetailBroker(value));
  };

  const [sortedBrokers, refreshBrokers] = useGetSortedBrokerListWithRefresh(
    RETAIL_BROKER_API_NAME
  );

  const translateLabel = staticDataHooks.useTranslator("uiLabels");

  return (
    <Disabled ifReadOnly>
      <PersonSelect
        person={broker}
        personList={sortedBrokers}
        onUpdatePerson={updateBroker}
        onUpdatePersonList={refreshBrokers}
        PersonCreationComponent={RetailBrokerCreation}
        label={translateLabel(labels.RETAIL_BROKER_TITLE, {
          default: "Retail Broker",
        })}
        showLabelOnCard
      />
    </Disabled>
  );
};

export default RetailBroker;
